module.exports = __webpack_public_path__ + "static/media/me.a0dbae6f.svg";